import React from "react";
import { connect } from "react-redux";

import Steps from "./components/Steps";
import Wizard from "./components/Wizard";
import Submitted from "./components/Submitted";
import "./App.css";
import { calculateLeadScore } from "./lead_score";

const App = ({ response, organization, person }) => {
  const leadScore = calculateLeadScore({ ...organization, ...person });

  return (
    <div className="app" id="contact-form-app">
      {response && response.error && (
        <div style={{ width: "100%", textAlign: "center" }}>
          <h2 style={{ fontSize: "120px", margin: 0 }}>🤔</h2>
          <h3>Oh nein! Irgendwas ist schiefgelaufen</h3>
          <p>Bitte versuche es noch einmal.</p>
        </div>
      )}
      {response && !response.errors && <Submitted leadScore={leadScore} organization={organization} />}
      {!response && (
        <>
          <div className="column-2">
            <Steps />
          </div>
          <div className="column-1">
            <Wizard />
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  submitting: state.submitting,
  response: state.response,
  organization: state.organization,
  person: state.person,
});

export default connect(mapStateToProps)(App);
